import type { PiniaPlugin } from 'pinia';

// Accessing via module reference (not destructured) so reads are live — the JS module
// exports `let sessionTracker` which is reassigned after each initializeSessionTracker call.
// Destructuring would capture undefined at load time and break the dispose guard.
// eslint-disable-next-line @typescript-eslint/no-require-imports
const sessionActivityUtil = require('@utils/session/session-activity.util') as {
    sessionTracker: { dispose: () => void; inactivityThreshold: number } | null | undefined;
    initializeSessionTracker: (config: { inactivityThreshold: number }) => void;
};

// Pinia equivalent of the Vuex session plugin (src/vuex/plugins/session.js).
// Watches subscription state for inactivity threshold changes and auth actions
// for logout/deauthentication to manage the session activity tracker.
// Per-store logic is wired in when each store migrates (APP-157985 for subscription,
// APP-157986 for auth).
export const sessionPlugin: PiniaPlugin = ({ store }) => {
    if (window.Cypress) return;

    if (store.$id === 'subscription') {
        store.$onAction(({ name, after }) => {
            if (name !== 'setActive' && name !== 'setActiveById') return;

            after(() => {
                const inactivityThreshold = Number(store.active.maxSessionInactivity);
                if (sessionActivityUtil.sessionTracker?.inactivityThreshold !== inactivityThreshold) {
                    setupTracker(inactivityThreshold);
                }
            });
        });
    }

    if (store.$id === 'auth') {
        // APP-157986: subscribe here to dispose tracker on logout and setAuthenticated(false)
    }
};

export function setupTracker (inactivityThreshold: number): void {
    if (window.Cypress) return;

    if (sessionActivityUtil.sessionTracker) {
        sessionActivityUtil.sessionTracker.dispose();
    }

    sessionActivityUtil.initializeSessionTracker({ inactivityThreshold });
}
